import storyboards from './storyboards.json';

const loaded = new Map();
export const loadReaction = result => {
  const src = storyboards[result]?.file;
  if (!src) return Promise.reject(new Error('Unknown reaction'));
  if (loaded.has(src)) return loaded.get(src);
  const promise = new Promise((resolve, reject) => {
    const image = new Image();
    const timeout = setTimeout(() => { image.onload = image.onerror = null; reject(new Error('Reaction load timeout')); }, 1800);
    image.onload = () => { clearTimeout(timeout); resolve(src); };
    image.onerror = () => { clearTimeout(timeout); reject(new Error('Reaction unavailable')); };
    image.src = src;
  });
  loaded.set(src, promise);
  promise.catch(() => loaded.delete(src));
  return promise;
};
export const warmScoreReactions = () => Object.keys(storyboards).forEach(key => loadReaction(key).catch(() => {}));